import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Box, Typography } from '@mui/material'

export default function TermAndCondition() {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Box>
      <Typography
        variant="body2"
        color="alternate.main"
        onClick={handleClickOpen}
        sx={{
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        {' '}
        Terms of Service
      </Typography>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Term and Conditions</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Box>
  )
}
